import React, { useContext } from "react";

import isEmpty from "lodash.isempty";
import { observer } from "mobx-react";
import {
  useRouter,
  usePathname,
  useSearchParams,
  useParams,
} from "../../hooks/useNavigation";
import { useTheme } from "styled-components";

import FindYourRole from "../../../components/FindYourRole/FindYourRole";
import { AppContext } from "../../../contexts/ApplicationStateProvider";
import ComponentContext from "../../../contexts/ComponentContext";
import { useStores } from "../../../contexts/StoreContext";
import useFilters from "../../customHooks/useFilters";
import defaultSearchFields from "../../helpers/defaultSearchFields";
import normalizeFieldConfiguration from "../../helpers/normalizeFieldConfiguration";

function HeroSearchForm() {
  const { filtersStore } = useStores();
  const { filters } = filtersStore;
  const { primaryColor } = useTheme();

  const router = useRouter();
  const params = useParams();
  const searchParams = useSearchParams();
  const search = Object.fromEntries(searchParams.entries());
  const combindedParms = { ...params, ...search };

  const pathname = usePathname();
  const { searchBoxComponent } = useContext(ComponentContext);
  const { isMobile } = useContext(AppContext);
  const { handleSubmit } = useFilters(true);

  const fieldsConfiguration = normalizeFieldConfiguration(
    searchBoxComponent?.filters
  );

  const fields = !isEmpty(fieldsConfiguration)
    ? fieldsConfiguration
    : defaultSearchFields;

  const handleApply = () => {
    handleSubmit(
      router,
      searchBoxComponent?.resultsUrl || pathname,
      filters,
      fields,
      combindedParms
    );
  };

  return (
    <FindYourRole
      buttonColor={primaryColor}
      buttonText={searchBoxComponent.buttonText}
      buttonTextColour={searchBoxComponent.buttonTextColour}
      fieldsConfiguration={fields}
      isInline={searchBoxComponent.inlineFields && !isMobile}
      isSticky={searchBoxComponent?.isSticky}
      onSubmit={handleApply}
      stickyPadding={searchBoxComponent?.stickyPadding}
      stickyTop={searchBoxComponent?.stickyTop}
      text={searchBoxComponent?.text}
      buttonHoverColour={searchBoxComponent?.buttonHoverColour}
    />
  );
}

export default observer(HeroSearchForm);
